/*global FakeCation*/
(function (FC) {
  "use strict";

  FC.utils.registerFilter('mapTone', function (imgData, cb, config) {
    var borders,
      bgHistBorders = {
        red: {
          min: 3,
          max: 252
        },
        green: {
          min: 3,
          max: 252
        },
        blue: {
          min: 3,
          max: 252
        }
      },
      tmpCanvas, tmpCtx;

    setTimeout(function () {
      if (config && config.bgImage) {
        tmpCanvas = document.createElement('canvas');
        tmpCanvas.width = config.bgImage.width;
        tmpCanvas.height = config.bgImage.height;
        tmpCtx = tmpCanvas.getContext('2d');

        tmpCtx.drawImage(config.bgImage, 0, 0);

        bgHistBorders = FC.colorUtils.histogramBorders(tmpCtx.getImageData(0, 0, tmpCanvas.width, tmpCanvas.height));
      }

      borders = FC.colorUtils.histogramBorders(imgData);

      // map red and blue completely and green only partially
      bgHistBorders.green = {
        min: (borders.green.min + bgHistBorders.green.min) / 2,
        max: (borders.green.max + bgHistBorders.green.max) / 2
      };
      imgData = FC.colorUtils.transformHistogram(imgData, borders, bgHistBorders);

      cb(imgData);

    }, 40);

  });

}(FakeCation));
